import { Locations } from './locations';

export interface LocationRegistration {
    locationNumber: number;
    registrationStatus: string;
}

export const createLocationRegistrationFromLocationSelection = ({
    number,
}: Locations): LocationRegistration | undefined => {
    if (!number) return undefined;
    return {
        locationNumber: number,
        registrationStatus: 'done',
    };
};
